
      (function() {
        var cookiebotIdPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
        var cookiebotId = import.meta.env.VITE_COOKIEBOT_ID;

        // XSS prevention: validate ID format before injecting script
        if (cookiebotId && cookiebotIdPattern.test(cookiebotId)) {
          var cookiebotScript = document.createElement('script');
          cookiebotScript.id = 'Cookiebot';
          cookiebotScript.src = 'https://consent.cookiebot.com/uc.js';
          cookiebotScript.setAttribute('data-cbid', cookiebotId);
          cookiebotScript.setAttribute('data-blockingmode', 'auto');
          cookiebotScript.type = 'text/javascript';
          document.head.appendChild(cookiebotScript);
        }
      })();
    